import React, { useContext, useEffect } from 'react';
import PaymentDetailsComponent from '../../../PaymentDetailsComponent';
import usePaymentTooltipParams from '../../hooks/usePaymentTooltipParams';
import { EqualHeightContext } from '../../../../utils/components/EqualHeight/context';
import { selectPrimaryCalculatorPaymentOptions } from '../../../../core/reducers/financialCalculators';
import { useAppSelector } from '../../../../core/utils';
import useIsSellingPriceFlag, { SellingPriceFlagSource } from '../../hooks/useIsSellingPriceFlag';
const PaymentDetails = ({ paymentTooltip, payment, sellingPriceFlagSource = SellingPriceFlagSource.geo, }) => {
    var _a;
    const { data, isFetching, error } = payment || {};
    const { setForceUpdate } = useContext(EqualHeightContext);
    const { paymentFrequency } = useAppSelector(selectPrimaryCalculatorPaymentOptions);
    const isSellingPriceProvince = useIsSellingPriceFlag(sellingPriceFlagSource);
    const paymentTooltipParams = usePaymentTooltipParams({
        product: paymentTooltip,
        payment: data,
        overriddenIsSellingProvince: isSellingPriceProvince,
    });
    const showPayment = !(isFetching || error || !data);
    useEffect(() => {
        setForceUpdate((value) => !value);
    }, [setForceUpdate, showPayment]);
    if (data && !isFetching) {
        return (React.createElement(PaymentDetailsComponent, { componentName: "UniCard-PaymentDetails", paymentLabel: {
                method: (data === null || data === void 0 ? void 0 : data.paymentMethod) ? (_a = data === null || data === void 0 ? void 0 : data.paymentMethod) === null || _a === void 0 ? void 0 : _a.toLowerCase() : '',
                frequency: paymentFrequency,
            }, terms: data === null || data === void 0 ? void 0 : data.term, paymentAmount: data === null || data === void 0 ? void 0 : data.preferredPaymentAmount, apr: data === null || data === void 0 ? void 0 : data.apr, informationalApr: data === null || data === void 0 ? void 0 : data.informationalApr, paymentTooltipParams: paymentTooltipParams }));
    }
    return null;
};
export default PaymentDetails;
